@if (variant === 'glass') {
	<span class="glass-tag">
		<ng-content></ng-content>
	</span>
} @else {
	<p-tag [ngClass]="['custom-tag', size, color || 'gray']">
		@if (icon) {
			<lucide-icon [name]="icon" [size]="size === 'small' ? 12 : 14" class="custom-tag-icon"></lucide-icon>
		}
		<span>{{ label }}</span>
	</p-tag>
}
